import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as SwimmingSvg } from './assets/swimming.svg';

const SwimmingIcon = React.forwardRef((args, ref) => <SvgIcon component={SwimmingSvg} ref={ref} {...args} />);

export default SwimmingIcon;
